<template>
  <Modal
    :id="'cmp_bookings_booking_add_artist'"
    @cancelled="onCancelClick"
  >
    <template slot="header"> {{ $t("add") }} {{ $t("Group") }} </template>
    <template slot="body">
      <div class="flex-cont" style="margin-bottom: 15px">
        <TextField
          class="m1"
          :id="'group'"
          v-bind="textFieldConfig"
          isModel
          :value="group"
          :placeholder="$t('group')"
          @valuechanged="onValueChange"
        ></TextField>
        <button class="dt-button s7 v1" @click="onOKClicked">
          {{ $t("add") }} {{ $t("Group") }}
        </button>
      </div>
      <SearchList
        :id="'groups'"
        :items="items"
        :keyProperty="'product_group_id'"
        :label="'product_group_name1'"
        :placeholder="'Search Artists'"
        @searched="onArtistsSearched"
        @selected="onArtistsSelected"
      />
    </template>
    <template slot="options">
  
     
      <button class="dt-button s7" @click="onCancelClick">{{$t('cancel')}}</button>
       <button class="dt-button s7 v1" @click="onOKClicked">{{$t('ok')}} </button>
    </template>
  </Modal>
</template>

<script>
import { Subject } from "rxjs";
import { addRemoveSet } from "../../../../utility";
import InputField from "../../../../plugins/text-field/input-field";
import { waitForAnimation, subscribeSubject } from "@/utility";
import Modal from "../../../../dt-plugins/modal/modal";
import SearchList from "@dtplugins/search-list/search-list";
import { releaseService } from "../../services/releases/releases.services";
import { ProductsService } from "../../services/products.service";
import {
  createTextFieldConfig,
  EventHooks,
} from "../../../../plugins/text-field";

export default {
  components: {
    InputField,
    Modal,
    SearchList,
  },
  props: {},
  data: function () {
    return {
      groups: [],
      searchString: "",
      selectedGroups: new Set(),
      searchSubject$: new Subject(),
      groupSearchResult: [],
      group: "",
      textFieldConfig: createTextFieldConfig({
        height: 42,
        showEditIconOnHover: false,
        box: true,

        valueChangedEvent: EventHooks.OnKeyup,
      }),
    };
  },
  computed: {
    external_id: function () {
      return this.$route.query.external_id;
    },
    items: function () {
      return this.searchString.length > 0
        ? this.groupSearchResult
        : this.groups;
    },
  },
  mounted: async function () {
    const groupList = await ProductsService.productGroupModal(
      this.external_id
    );

    this.groups = groupList.data.groups;
    console.log("DATA RESP", groupList.data.groups);
    subscribeSubject(
      this,
      this.searchSubject$,
      (searchString) => {
        releaseService
          .searchUnrelatedArtists(
            this.external_id,
            searchString
          )
          .then((res) => {
            console.warn(searchString, res);
            this.groupSearchResult = res.data.groups;
          });
      }
    );
  },
  methods: {
    onOKClicked: function () {
      const payload = Array.from(this.selectedGroups);
      console.warn(Array.from(this.selectedGroups));
      if (payload.length > 0) {
        this.$emit("create", {
          groups: JSON.stringify(payload),
          action:'add_groups'
        });
      } else {
        this.$emit("create", { groups: this.group ,action:'add_new_group'});
      }
    },
    onCancelClick: function () {
      this.$emit("cancelled", true);
    },
    onCheckboxChange: function (event, artist) {
      this.selectedGroups = addRemoveSet(
        event.target.checked,
        this.selectedGroups,
        artist.product_group_id
      );
    },
    onArtistsSelected: function (selectedGroups) {
      this.selectedGroups = selectedGroups;
    },
    onArtistsSearched: function (searchString) {
      releaseService
        .searchUnrelatedArtists(this.external_id, searchString)
        .then((res) => {
          this.searchString = searchString;
          this.groupSearchResult = res.data.groups;
          console.warn(
            this.groupSearchResult,
            searchString,
            res
          );
        });
    },
    onSearchInputKeyup: function (event) {
      this.searchString = event.target.value;
      this.searchSubject$.next(event.target.value);
    },

    onValueChange: function (key, value) {
      //console.log("WERE",key,value)
      this.group = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.cmp_bookings_booking_add_artist {
  .flex-cont {
    display: flex;
    .m1 {
      flex: 3;
    }
    .v1 {
      flex: 1;
      margin-left: 10px;
      margin-top: 10px;
    }
  }
}
.groups-container {
  height: 360px;
  overflow: auto;
  border: 1px solid var(--sprt-5);
  .groups {
    .artist-item {
      padding: 5px;

      .checkbox-container {
        padding: 5px 0px;
      }

      &:nth-child(8n),
      &:nth-child(8n-2),
      &:nth-child(8n + 3),
      &:nth-child(8n + 1) {
        background: var(--sprt-8);
      }
    }
  }
}
</style>
